export default {
  tab: {
    Result: 'TỔNG QUAN',
    Performance: 'BIẾN ĐỘNG',
    Financial: 'TÀI CHÍNH',
    Technical: 'KỸ THUẬT',
  },

  button: {
    TOP_SCREEN: 'BỘ LỌC TIÊU BIỂU',
    MY_SCREEN: 'BỘ LỌC CÁ NHÂN',
    APPLY: 'ÁP DỤNG',
    SAVE: 'LƯU',
    result: 'KẾT QUẢ SÀNG LỌC ',
    CREATE: 'KHỞI TẠO',
    DELETE: 'XÓA',
    CANCEL: 'HỦY BỎ',
    export: 'TẢI XUỐNG',
  },

  financialHeader: {
    TICKER: 'MÃ',
    PRICE: 'GIÁ',
    PERCENT_PRICE_CHANGE: '% THAY ĐỔI',
    ISA3: 'DOANH THU<br>(TTM)',
    ISA20: 'LỢI NHUẬN<br>(TTM)',
    RTD14: 'EPS<br>(TTM)',
    RTD7: 'BVPS (VND)',
    RTD21: 'P/E',
    RTD25: 'P/B',
    NET_PROFIT_GROWTH: 'Tăng trưởng lãi thuần (TTM)',
    EBIT_MARGIN: 'Tỷ suất EBIT (TTM)',
  },
  resultHeader: {
    TICKER: 'MÃ',
    SECTOR: 'NGÀNH',
    RTD21: 'P/E',
    RTD11: 'Vốn hóa',
    RTD36: 'Tỷ Suất Cổ Tức',
    RTD20: 'Tỷ Suất Cổ Tức',
    AVERAGE_VOLUME_3MONTH: 'KLGDTB 3M',
    CLOSE_PRICE: 'Giá đóng cửa',
    OVER_SMA50: 'VƯỢT SMA50',
    ORGANIZATION_OWNERSHIP: 'SH CĐ lớn',
    RTD14: 'EPS<br>(TTM)',
    RTD25: 'P/B',
    RTD19: 'BETA',
    RTD55: 'EPS (TTM) tăng trưởng',
    RTQ12: 'ROE',
    RTQ160: 'T.trưởng K.doanh 3 năm',
    RSI: 'RSI',
    RQD25: 'P/B<br>(MRQ)',
    RTD52: 'Tăng trưởng EPS (TTM)',
    RYD52: 'EPS t.trưởng từng năm',
    RYQ160: 'T.trưởng doanh số trong 3 năm ',
    RYQ166: 'Lợi nhuận t.trưởng trung bình 3 năm',
    RYQ176: 'T.trưởng vốn chủ sở hữu 3 năm',
    FREE_FLOAT_RATE: '% FLOAT RATE',
    GROWTH: 'Điềm đầu tư Tăng trưởng',
    MOMENTUM: 'Điềm đầu tư Động lực',
    VALUE: 'Điểm đầu tư Giá trị',
    VGM: 'Điểm đầu tư Kết hợp',
    ICBRANK: 'FiinTrade xếp hạng',
    INDEXRANK: 'INDEX RANK',
    CAPITAL_STRUCTURE: 'CẤU TRÚC VỐN',
    CFO: 'CFO',
    DEBT: 'NỢ',
    EQUITY_INSSURANCE: 'EQUITY INSSURANCE',
    FINANCIAL_PLAN: 'KẾ HOẠCH TÀI CHÍNH',
    FINANCIAL_STRENGTH: 'SỨC MẠNH TÀI CHÍNH',
    GROSSMARGIN: 'BIÊN LỢI NHUẬN GỘP',
    PROFIT_GROWTH: 'TĂNG TRƯỞNG LỢI NHUẬN',
    REVENUE_GROWTH: 'TĂNG TRƯỞNG DOANH THU',
    ROE: 'ROE',
    ROA: 'ROA',
    RTD26: 'P/S<br>(TTM)',
    RTD28: 'Giá - Dòng Tiền<br>(TTM)',
    RTD40: 'Giá- Dòng tiền tự do<br>(TTM)',
    RTD27: 'Giá - T.sản hữu hình<br>(MRQ)',
    RTQ166: 'T.trưởng l.nhuận t.bình 3 năm',
    Rtq176: 'T.trưởng vốn hóa 3 năm',
    TOTALMATCHVOLUME: 'Khối lượng GD',
    AVERAGEVOLUME2WEEK: 'Kl T.bình 10 phiên',
    PERCENTPRICECHANGE1DAY: 'Biến động giá 1 ngày',
    PERCENTPRICECHANGE1WEEK: 'Biến động giá 1 tuần',
    PERCENTPRICECHANGE1MONTH: 'Biến động giá 1 tháng',
    PERCENTPRICECHANGE3MONTH: 'Biến động giá 3 tháng',
    PERCENTPRICECHANGE6MONTH: 'Biến động giá 6 tháng',
    PERCENTPRICECHANGE52WEEK: 'Biến động giá 52 tuần',
    PERCENTPRICECHANGEYTD: 'Biến động giá từ đầu năm',
    SMA20: 'MA(20)',
    SMA50: 'MA(50)',
    SMA100: 'MA(100)',
    AVERAGEVOLUME1WEEK: 'Kl T.bình 5 phiên',
    AVERAGEVOLUME1MONTH: 'Kl T.bình 20 phiên',
    REVTTM: 'Doanh thu<br>(TTM)',
    ISA20TTM: 'Lợi nhuận thuần<br>(TTM)',
    RTQ2: 'HỆ SỐ THANH TOÁN NHANH<br>(TTM)',
    RTQ3: 'HỆ SỐ THANH TOÁN HIỆN HÀNH<br>(TTM)',
    RTQ4: 'NỢ DÀI HẠN/VỐN CSH<br>(TTM)',
    RTQ6: 'TỔNG NỢ/VỐN CSH<br>(TTM)',
    REVY: 'Doanh thu<br>(Năm trước)',
    ISA20Y: 'Lợi nhuận thuần<br>(Năm trước)',
    RYQ25: 'Biên lãi gộp<br>(Năm trước)',
    RYQ29: 'Biên lãi ròng<br>(Năm trước)',
    RYQ2: 'HỆ SỐ THANH TOÁN NHANH<br>(NĂM TRƯỚC)',
    RYQ3: 'HỆ SỐ THANH TOÁN HIỆN HÀNH<br>(NĂM TRƯỚC)',
    RYQ4: 'NỢ DÀI HẠN/VỐN CSH<br>(NĂM TRƯỚC)',
    RYQ6: 'TỔNG NỢ/VỐN CSH<br>(NĂM TRƯỚC)',
    RTD43: 'Cổ Tức',
    RTD36AVG: 'Tỉ Suất Cổ Tức T.Bình 3 Năm',
    RTD20AVG: 'Tỉ Suất Cổ Tức T.Bình 3 Năm',
    RTD51: 'Tỉ Lệ Xuất Chi',
    MA9: 'MA9',
    MA20: 'MA20',
    MA50: 'MA50',
    MA75: 'MA75',
    MA100: 'MA100',
    MA200: 'MA200',
    ADX: 'ADX',
    CCI: 'CCI',
    ROC: 'ROC',
    STOCHASTIC: 'STOCH',
    WILLIAMS: 'WILLIAMS',
    MFI: 'MFI',
    TOTALMATCHVALUE: 'Giá trị GD',
    AVERAGEVALUE1WEEK: 'Giá trị GD T.bình 5D',
    AVERAGEVALUE2WEEK: 'Giá trị GD T.bình 10D',
    AVERAGE_VALUE_1MONTH: 'Giá trị GD T.bình 20D',
    AVERAGEVALUE3MONTH: 'Giá trị GD T.bình 3M',
    RTQ78: 'Tăng trưởng doanh thu (YoY)',
    RTQ83: 'Tăng trưởng lợi nhuận thuần (YoY)',
    REV: 'Doanh thu <br> (quý gần nhất)',
    PRF: 'Lợi nhuận thuần <br> (quý gần nhất)',
    REVGROWTH: 'Tăng trưởng doanh thu <br> quý gần nhất (YoY)',
    PRFGROWTH: 'Tăng trưởng lợi nhuận thuần <br> quý gần nhất (YoY)',
    RTQ25: 'Biên lãi gộp<br>(TTM)',
    RTQ29: 'Biên lãi ròng<br>(TTM)',
    RTQ27: 'Biên EBIT <br> (TTM)',
    RQQ27: 'Biên EBIT <br> (Quý)',
    RQQ29: 'Biên lợi nhuận thuần <br> (Quý)',
    RQQ25: 'Biên lợi nhuận gộp <br> (Quý)',
    F_SCORE: 'F-Score <br> (TTM)',
    CANSLIM: 'Canslim <br> (TTM)',
    RTQ1: 'Tỉ suất thanh toán tiền mặt <br> (TTM)',
    RTQ77: 'Khả năng chi trả lãi vay <br> (TTM)',
    ForeignerRoom: 'Room nước ngoài',
    ForeignerPercentage: 'Sở hữu nước ngoài',
    CorpOwnership: 'Tỉ lệ tổ chức sở hữu',
    RTQ79: 'T.trưởng LN gộp (YoY)',
    RTQ7: 'Nợ phải trả/ Tổng tài sản (TTM)',
    RQQ6: 'Nợ phải trả/ Vốn chủ sở hữu (quý)',
    RQQ23: 'ROIC (quý)',
  },
  screenerMessage: {
    confirmDelete: 'Xóa bộ lọc?',
    warningTitle: 'Không thể lưu bộ lọc!',
    addCriteria: 'THÊM CHỈ TIÊU',
    selectedCriteria: 'CHỈ TIÊU ĐÃ CHỌN',
    errorEmptyParam: 'Để lưu bộ lọc, bạn cần chọn ít nhất 1 chỉ tiêu',
    errorEmptyname: 'Hãy điền tên cho bộ lọc',
    placeHolder: 'Đặt tên bộ lọc',
    warnMaxParam: 'Giới hạn chỉ tiêu',
    errorMaxParam: 'Bạn không thể lựa chọn nhiều hơn 10 chỉ tiêu. Hãy thử lại.',
  },
  allExchanges: 'Tất cả sàn',
  allSectors: 'Tất cả ngành',
};
